export const questions = [
  {
    id: 'budget',
    question: 'What is your gift budget?',
    helper: 'We use a range rather than a live price, since Amazon prices can change.',
    type: 'single',
    required: true,
    options: [
      { value: 'under25', label: 'Under $25' },
      { value: '25to50', label: '$25–$50' },
      { value: '50to100', label: '$50–$100' },
      { value: '100to200', label: '$100–$200' },
      { value: 'over200', label: 'Over $200' },
    ],
  },
  {
    id: 'age',
    question: 'What is their age range?',
    type: 'single',
    required: true,
    options: [
      { value: 'baby', label: 'Baby or toddler (0–3)' },
      { value: 'child', label: 'Child (4–8)' },
      { value: 'tween', label: 'Tween (9–12)' },
      { value: 'teen', label: 'Teen (13–17)' },
      { value: 'young-adult', label: 'Young adult (18–25)' },
      { value: 'adult', label: 'Adult (26–44)' },
      { value: 'mature-adult', label: 'Adult (45–64)' },
      { value: 'senior', label: 'Senior (65+)' },
    ],
  },
  {
    id: 'relationship',
    question: 'What is your relationship to them?',
    type: 'single',
    required: true,
    options: [
      { value: 'partner', label: 'Partner or spouse' },
      { value: 'parent', label: 'Parent' },
      { value: 'child-recipient', label: 'My child' },
      { value: 'sibling', label: 'Sibling' },
      { value: 'friend', label: 'Friend' },
      { value: 'coworker', label: 'Coworker' },
      { value: 'extended-family', label: 'Extended family' },
      { value: 'host', label: 'Host, teacher, or helper' },
    ],
  },
  {
    id: 'occasion',
    question: 'What kind of moment is this gift for?',
    type: 'single',
    required: true,
    options: [
      { value: 'christmas', label: 'Christmas celebration' },
      { value: 'stocking', label: 'Stocking stuffer' },
      { value: 'secret-santa', label: 'Secret Santa or gift exchange' },
      { value: 'milestone', label: 'A meaningful milestone' },
      { value: 'host-thanks', label: 'A thank-you or host gift' },
      { value: 'just-because', label: 'A thoughtful surprise' },
    ],
  },
  {
    id: 'personality',
    question: 'How would you describe their personality?',
    helper: 'Choose up to 3.',
    type: 'multi',
    required: true,
    maxSelections: 3,
    options: [
      { value: 'curious', label: 'Curious' },
      { value: 'creative', label: 'Creative' },
      { value: 'practical', label: 'Practical' },
      { value: 'sentimental', label: 'Sentimental' },
      { value: 'social', label: 'Social' },
      { value: 'introverted', label: 'Quiet or introverted' },
      { value: 'adventurous', label: 'Adventurous' },
      { value: 'organized', label: 'Organized' },
      { value: 'playful', label: 'Playful' },
      { value: 'luxury-loving', label: 'Enjoys the finer things' },
    ],
  },
  {
    id: 'giftStyle',
    question: 'What should the gift feel like?',
    helper: 'Choose up to 3.',
    type: 'multi',
    required: true,
    maxSelections: 3,
    options: [
      { value: 'useful', label: 'Useful every day' },
      { value: 'fun', label: 'Fun and surprising' },
      { value: 'cozy', label: 'Cozy and comforting' },
      { value: 'meaningful', label: 'Personal and meaningful' },
      { value: 'experience', label: 'An experience or activity' },
      { value: 'upgrade', label: 'An upgrade they would not buy' },
      { value: 'learn', label: 'Something to learn or explore' },
      { value: 'shareable', label: 'Something to enjoy together' },
    ],
  },
  {
    id: 'hobbies',
    question: 'Which hobbies do they enjoy?',
    helper: 'Choose up to 5, or skip if you are unsure.',
    type: 'multi',
    required: false,
    maxSelections: 5,
    options: [
      { value: 'reading', label: 'Reading' },
      { value: 'gaming', label: 'Gaming' },
      { value: 'cooking', label: 'Cooking or baking' },
      { value: 'fitness', label: 'Fitness or sports' },
      { value: 'gardening', label: 'Gardening' },
      { value: 'photography', label: 'Photography or video' },
      { value: 'music', label: 'Music' },
      { value: 'art', label: 'Art or crafts' },
      { value: 'diy', label: 'DIY or woodworking' },
      { value: 'collecting', label: 'Collecting' },
      { value: 'travel', label: 'Travel' },
      { value: 'outdoors', label: 'Camping or outdoors' },
      { value: 'hosting', label: 'Hosting friends and family' },
      { value: 'puzzles', label: 'Puzzles or games' },
    ],
  },
  {
    id: 'interests',
    question: 'What topics naturally grab their attention?',
    helper: 'Choose up to 5.',
    type: 'multi',
    required: false,
    maxSelections: 5,
    options: [
      { value: 'technology', label: 'Technology and gadgets' },
      { value: 'fashion', label: 'Fashion and style' },
      { value: 'home', label: 'Home and decor' },
      { value: 'wellness', label: 'Health and wellness' },
      { value: 'pets', label: 'Pets and animals' },
      { value: 'food', label: 'Food and drink' },
      { value: 'movies', label: 'Movies and TV' },
      { value: 'science', label: 'Science and nature' },
      { value: 'history', label: 'History and culture' },
      { value: 'beauty', label: 'Beauty and self-care' },
      { value: 'cars', label: 'Cars and motorsports' },
      { value: 'sustainability', label: 'Sustainable living' },
    ],
  },
  {
    id: 'lifeStage',
    question: 'What best describes their everyday life?',
    helper: 'Choose up to 3.',
    type: 'multi',
    required: false,
    maxSelections: 3,
    options: [
      { value: 'student', label: 'Student' },
      { value: 'remote-worker', label: 'Works from home' },
      { value: 'commuter', label: 'Commutes regularly' },
      { value: 'busy-parent', label: 'Busy parent or caregiver' },
      { value: 'frequent-traveler', label: 'Frequent traveler' },
      { value: 'retired', label: 'Retired' },
      { value: 'maker', label: 'Makes or builds things' },
      { value: 'entertainer', label: 'Often hosts people' },
    ],
  },
  {
    id: 'techComfort',
    question: 'How comfortable are they with technology?',
    type: 'single',
    required: true,
    options: [
      { value: 'low-tech', label: 'Prefers simple, low-tech things' },
      { value: 'everyday-tech', label: 'Comfortable with everyday tech' },
      { value: 'tech-lover', label: 'Loves new gadgets' },
      { value: 'no-tech-preference', label: 'No strong preference' },
    ],
  },
  {
    id: 'activity',
    question: 'How do they prefer to spend free time?',
    type: 'single',
    required: true,
    options: [
      { value: 'homebody', label: 'Relaxing at home' },
      { value: 'active', label: 'Staying active' },
      { value: 'out-and-about', label: 'Going out and exploring' },
      { value: 'balanced', label: 'A mix of everything' },
    ],
  },
  {
    id: 'homeSituation',
    question: 'What should we know about their space?',
    helper: 'Choose any that apply.',
    type: 'multi',
    required: false,
    maxSelections: 3,
    options: [
      { value: 'small-space', label: 'They have limited space' },
      { value: 'shared-space', label: 'They share their space' },
      { value: 'new-home', label: 'They recently moved' },
      { value: 'home-office', label: 'They have a home office' },
      { value: 'outdoor-space', label: 'They have a yard or patio' },
      { value: 'lots-of-space', label: 'Space is not a concern' },
    ],
  },
  {
    id: 'preferences',
    question: 'Which gift qualities would they appreciate?',
    helper: 'Choose up to 4.',
    type: 'multi',
    required: false,
    maxSelections: 4,
    options: [
      { value: 'personalized', label: 'Personalized' },
      { value: 'handmade', label: 'Handmade or artisanal' },
      { value: 'eco-friendly', label: 'Eco-friendly' },
      { value: 'subscription', label: 'A subscription' },
      { value: 'consumable', label: 'Consumable or clutter-free' },
      { value: 'premium', label: 'Premium quality' },
      { value: 'portable', label: 'Portable' },
      { value: 'family-friendly', label: 'Family-friendly' },
    ],
  },
  {
    id: 'avoid',
    question: 'Anything we should avoid?',
    helper: 'Choose any that apply, or skip.',
    type: 'multi',
    required: false,
    options: [
      { value: 'avoid-clutter', label: 'More clutter' },
      { value: 'avoid-tech', label: 'Complicated technology' },
      { value: 'avoid-sizing', label: 'Clothing sizes' },
      { value: 'avoid-food', label: 'Food or drink' },
      { value: 'avoid-fragrance', label: 'Fragrance or skincare' },
      { value: 'avoid-noise', label: 'Noisy gifts' },
      { value: 'avoid-maintenance', label: 'High-maintenance items' },
    ],
  },
  {
    id: 'clue',
    question: 'Is there one more clue that would help?',
    helper: 'Optional: mention a favorite team, fandom, animal, color, hobby, or something they have talked about.',
    type: 'text',
    required: false,
    placeholder: 'For example: loves the Yankees, just adopted a cat, learning guitar…',
  },
];

export const questionById = Object.fromEntries(questions.map((question) => [question.id, question]));

export const getOptionLabel = (questionId, value) => {
  const question = questionById[questionId];
  return question?.options?.find((option) => option.value === value)?.label || value;
};
